import React from "react";
import Seo from "../components/Seo";
import { ESTUDIO, PROCESO } from "../data/estudio";
import { PAGES, breadcrumbJsonLd } from "../seo/config";

const crumbs = [
  { name: "Inicio", path: "/" },
  { name: "Nosotros", path: "/sobre-omega" },
];

const SobrePage = () => (
  <>
    <Seo
      title={PAGES.estudio.title}
      description={PAGES.estudio.description}
      keywords={PAGES.estudio.keywords}
      path={PAGES.estudio.path}
      jsonLd={[breadcrumbJsonLd(crumbs)]}
    />

    <section className="bg-sand-50 pb-24 pt-28 md:pt-32">
      <div className="container-page">
        <h1 className="font-display text-display-md font-bold text-navy-900">
          Omega Digital fotografía eventos y sesiones en estudio.
        </h1>
        <p className="section-copy mt-6 max-w-2xl">
          Dos servicios con precio publicado. Al evento vamos nosotros, con la iluminación. La
          sesión se hace en el estudio, con fondo y luz ya montados.
        </p>

        <dl className="mt-14 grid gap-8 sm:grid-cols-2">
          <div>
            <dt className="text-sm text-navy-500">Cobertura</dt>
            <dd className="mt-2 font-display text-xl font-bold text-navy-900">{ESTUDIO.cobertura[0]}</dd>
            <dd className="mt-1 text-navy-600">{ESTUDIO.cobertura[1]}</dd>
          </div>
          <div>
            <dt className="text-sm text-navy-500">Facturación</dt>
            <dd className="mt-2 font-display text-xl font-bold text-navy-900">
              {ESTUDIO.emiteFactura ? "Emite factura. Contribuyente de IVA." : "Boleta."}
            </dd>
          </div>
          <div>
            <dt className="text-sm text-navy-500">Horario</dt>
            <dd className="mt-2 font-display text-xl font-bold text-navy-900">
              {ESTUDIO.horario.dias}, {ESTUDIO.horario.desde}–{ESTUDIO.horario.hasta}
            </dd>
            <dd className="mt-1 text-navy-600">{ESTUDIO.horario.nota}</dd>
          </div>
          <div>
            <dt className="text-sm text-navy-500">Comunas frecuentes</dt>
            <dd className="mt-2 text-navy-800">{ESTUDIO.comunasDestacadas.join(", ")}</dd>
          </div>
        </dl>

        <ol className="mt-16 grid gap-8 md:grid-cols-3">
          {PROCESO.map((step, index) => (
            <li key={step.title}>
              <p className="font-display text-3xl font-bold text-sand-500">{index + 1}</p>
              <h2 className="mt-3 font-display text-xl font-bold">{step.title}</h2>
              <p className="mt-2 text-navy-600">{step.copy}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  </>
);

export default SobrePage;
